interface ModelField {
  type?: string;
}

export function generateSampleData( fields: Record<string, ModelField> ): Record<string, any> | null {
  if ( !fields ) return null;

  return Object.entries( fields ).reduce( ( acc, [ fieldName, field ] ) => {
    let sampleValue;

    switch ( field.type ) {
      case 'string':
        sampleValue = 'sample_string';
        break;
      case 'int':
      case 'integer':
        sampleValue = 123;
        break;
      case 'number':
        sampleValue = 123.45;
        break;
      case 'boolean':
        sampleValue = true;
        break;
      case 'timestamp':
        sampleValue = '2025-01-01 12:00:00';
        break;
      case 'array':
        sampleValue = [ 'item1', 'item2' ];
        break;
      case 'object':
        sampleValue = { key: 'value' };
        break;
      default:
        sampleValue = `<${ field.type }>`;
    }

    acc[fieldName] = sampleValue;
    return acc;
  }, {} as Record<string, any> );
}
